import type { PartialDeep } from 'type-fest';

import { UserGuide, UserInitializationState, UserPreference } from '@/types_cp/user';
import { UserSettings } from '@/types_cp/user/settings';
import { AsyncLocalStorage } from '@/utils_cp/local-storage';

import { IUserService } from './type';
import { DEFAULT_PREFERENCE } from '@/const/user';

export class ClientService implements IUserService {
  private preferenceStorage: AsyncLocalStorage<UserPreference>;

  constructor() {
    this.preferenceStorage = new AsyncLocalStorage('SILVERTIGER_PREFERENCE');
  }

  getUserRegistrationDuration = async () => {
    throw new Error('Method not implemented.');
  };

  async getUserState(): Promise<UserInitializationState> {

    return {
      avatar: '',
      canEnablePWAGuide: false,
      canEnableTrace: false,
      hasConversation: false,
      isOnboard: true,
      preference: DEFAULT_PREFERENCE,
      settings: {},
      userId: "1",
    };
  }

  getUserSSOProviders = async () => {
    // Account not exist on next-auth in client mode, no need to implement this method
    return [];
  };

  unlinkSSOProvider = async () => {
    // Account not exist on next-auth in client mode, no need to implement this method
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateUserSettings = async (patch: PartialDeep<UserSettings>, _?: any) => {
  };

  resetUserSettings = async () => {
  };

  async updateAvatar(_avatar: string) {
  }

  async updatePreference(preference: Partial<UserPreference>) {
    await this.preferenceStorage.saveToLocalStorage(preference);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async updateGuide(guide: Partial<UserGuide>) {
    throw new Error('Method not implemented.');
  }
}
